import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      width: 608,
    },

    input: {},
  }),
  {
    name: 'ExportAssetNamePopup',
  }
);
